import { render, staticRenderFns } from "./Offline.vue?vue&type=template&id=188f496e&scoped=true&"
import script from "./Offline.vue?vue&type=script&lang=js&"
export * from "./Offline.vue?vue&type=script&lang=js&"
import style0 from "./Offline.vue?vue&type=style&index=0&id=188f496e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188f496e",
  null
  
)

export default component.exports